module.exports = __webpack_public_path__ + "static/media/up-arrow-yellow.dc22d131.svg";